// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".intersection-anchor--header{margin-bottom:var(--grid-header-height-mobile);margin-top:var(--grid-header-height-mobile-negative)}@media screen and (min-width:769px){.intersection-anchor--header{margin-bottom:var(--grid-header-height);margin-top:var(--grid-header-height-negative)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
